import { Tile } from "@blacknut/javascript-sdk/dist";
import { logD, logE } from "@blacknut/logging/dist";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAppNavigation } from "src/utils/Navigation/useAppNavigation";
import { addToFavorite, removeFromFavorite } from "../../redux/actions/Game";
import { State } from "../../redux/reducers";

const TAG = "TileContainer";

export const useTile = (props: {
  item: Tile;
  previewMode?: boolean;
  pageUuid?: string;
}) => {
  const { item, previewMode = false, pageUuid } = props;

  const gameId = item.game?.id;
  const link = item.link?.url;
  const gameState = useSelector((state: State) => state.gamesState.games[gameId || ""]);
  const dispatch = useDispatch();
  const { navigate } = useAppNavigation();
  return {
    onClick: useCallback(() => {
      if (previewMode) {
        logD(TAG, "tile clicked in preview mode");
        return;
      }
      if (item.game) {
        navigate(`/game/${item.game.id}`);
      }
      if (link) {
        if (link?.startsWith("blacknut://")) {
          navigate(link.replace("blacknut://", "/")); //FIXME deeplink scheme
        } else if (link.startsWith("http")) {
          if (item?.link?.uuid && pageUuid) {
            navigate(`/link/${pageUuid}/${item.link.uuid}`);
          } else {
            window.open(link, "_blank");
          }
        } else {
          navigate(link);
        }
      }
      if (item.page) {
        navigate(`/page/${item.page.uuid}`);
      }
      if (item.marketing) {
        navigate(`/lemag/${item.marketing.uuid}`);
      }
      if (item.lemag) {
        navigate(`/lemag/${item.lemag.uuid}`);
      }
    }, [
      previewMode,
      item.game,
      item.page,
      item.marketing,
      item.lemag,
      item.link?.uuid,
      link,
      navigate,
      pageUuid,
    ]),

    toggleFavorite: useCallback(async () => {
      if (!gameState || !gameState.favoritePending || !gameState?.game) {
        return;
      }
      if (gameState?.favorite) {
        try {
          await removeFromFavorite(gameState?.game.id)(dispatch);
        } catch (e) {
          logE(TAG, "Caught error toggling favorite", e);
        }
      } else {
        try {
          await addToFavorite(gameState?.game.id)(dispatch);
        } catch (e) {
          logE(TAG, "Caught error toggling favorite", e);
        }
      }
    }, [dispatch, gameState]),
  };
};
